// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"92888":"ec1674355dc656aa","95405":"a7251eb15d263e1c"}[chunkId] + ".css";
};